import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from '../shared/shared.module';
import { FinishProRoutingModule } from './finish-pro-routing.module';
import { FinishProComponent } from './finish-pro.component';
import { IntroComponent } from './pages/intro/intro.component';
import { SignatureStatusComponent } from './pages/signature-status/signature-status.component';
import { ThanksComponent } from './pages/thanks/thanks.component';
import { AccessCodeComponent } from './pages/access-code/access-code.component';
import { LoadingProComponent } from './components/loading-pro/loading-pro.component';
import { DocumentViewerComponent } from './pages/document-viewer/document-viewer.component';
import { AuthService, DocumentService, OperationService, CircuitService } from '../api';
import { SignatureModule } from './components/signature/signature.module';
import { FinishProService } from './services/finish-pro.service';
import { WebSocketSignerProComponent } from './components/signature/signature-pad/webSocketsigner.component';
import { OperationGuardService } from './services/operation-guard.service';
import { ConfirmModalComponent } from './components/modal/confirm-modal/confirm-modal.component';
import { LoadingService } from '../shared/loading/loading.service';
import { DownloadDocumentModalComponent } from './components/modal/download-document-modal/download-document-modal.component';
import { LocationService } from './services/location.service';
import { ProLogoImgModule } from './directives/logo-directive/pro-logo-img.module';
import { DocumentsHeaderComponent } from './components/documents-header/documents-header.component';
import { TermsModalComponent } from './components/modal/terms-modal/terms-modal.component';
import { ErrorComponent } from './pages/error/error.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { AuthorizationModalComponent } from './components/modal/authorization-modal/authorization-modal.component';
import { ChatModule } from '../components/chat/chat.module';
import { HighlightModule } from 'ngx-highlightjs';
import { DynamicSignatureModalComponent } from './components/modal/dynamic-signature-modal/dynamic-signature-modal.component';
import { LanguagesModule } from '../shared/languages/languages.module';
import { LanguageService } from './services/language.service';
import { DocumentViewerModalComponent } from './pages/document-viewer/modal/document-viewer-modal.component';
import { FilesUploadModule } from '../modules/files-upload/files-upload.module';
import { HelpModalComponent } from './components/modal/help-modal/help-modal.component';
import { OperationNOTEComponent } from './pages/operation-NOTE/operation-NOTE.component';
import { SimpleSignComponent } from './pages/simple-sign/simple-sign.component';

@NgModule({
  declarations: [
    FinishProComponent,
    IntroComponent,
    SignatureStatusComponent,
    AccessCodeComponent,
    ThanksComponent,
    LoadingProComponent,
    DocumentViewerComponent,
    WebSocketSignerProComponent,
    ConfirmModalComponent,
    TermsModalComponent,
    DocumentViewerModalComponent,
    DownloadDocumentModalComponent,
    DocumentsHeaderComponent,
    ErrorComponent,
    TermsAndConditionsComponent,
    DynamicSignatureModalComponent,
    AuthorizationModalComponent,
    HelpModalComponent,
    OperationNOTEComponent,
    SimpleSignComponent
  ],
  imports: [
    SharedModule,
    FinishProRoutingModule,
    PdfViewerModule,
    SignatureModule,
    ProLogoImgModule,
    NgOtpInputModule,
    HighlightModule,
    LanguagesModule,
    FilesUploadModule
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    FinishProService,
    OperationGuardService,
    OperationService,
    DocumentService,
    LoadingService,
    LocationService,
    AuthService,
    CircuitService,
    LanguageService,
    ChatModule,
    HighlightModule,
  ],
})
export class FinishProModule { }
